import { watch } from 'vue'
import type { Ref } from 'vue'

export function useFilterChipsSync(
  currentFilters: Ref<Record<string, unknown> | null | undefined>,
  setDataToRenderFilterChips: () => void,
  setDataToRenderFilterTags: () => void
) {
  const nuxtApp = useNuxtApp()

  watch(
    () => currentFilters.value,
    () => {
      setDataToRenderFilterChips()
    },
    { deep: true }
  )

  watch(
    () => nuxtApp.$store.getters['filter/filterTags'],
    () => {
      setDataToRenderFilterTags()
    },
    { deep: true }
  )
}
